import { extrasVM } from '../Extras.page';
import { Col } from '@design-system/components/grid/grid';
import { Typography } from '@design-system/components/typography/typography';
import { Button } from '@design-system/components/button/button';
import {
  filterVisibilityOptions,
  filterAccessOptions,
  filterTypeOptions,
} from '../viewModel/extras.mappers';
import * as styles from './ExtrasNoResults.css';

const optionsMap = {
  visibility: filterVisibilityOptions,
  access: filterAccessOptions,
  type: filterTypeOptions,
};

export const ExtrasNoResults = () => {
  const vm = extrasVM.useValue();

  if (!vm.isFilteredResultsEmpty) return null;

  const handleClearFilters = () => {
    vm.dispatch('SetSearch', '');
    vm.dispatch('SetFilter', { type: '', access: '', visibility: '' });
  };

  const getContextMessage = (): string => {
    const parts: string[] = [];

    if (vm.search) {
      parts.push(`"${vm.search}"`);
    }

    const activeFilters = (['visibility', 'access', 'type'] as const).flatMap(
      (filterType) => {
        const value = vm.filters[filterType];
        if (!value) return [];
        const label = optionsMap[filterType].find(
          (o) => o.value === value,
        )?.label;
        return label ? [label] : [];
      },
    );

    if (activeFilters.length > 0) {
      parts.push(`filter: ${activeFilters.join(', ')}`);
    }

    return parts.length > 0 ? ` for ${parts.join(' and ')}` : '';
  };

  return (
    <Col gap="l" center className={styles.container}>
      <Typography variant="body" size="large" fontWeight="medium">
        No results found{getContextMessage()}
      </Typography>
      <Typography variant="body" size="medium">
        Try adjusting your search or filters
      </Typography>
      <Button variant="outlined" onClick={handleClearFilters}>
        Clear filters
      </Button>
    </Col>
  );
};
